import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useLang } from '../hooks/useLang';
import mollaImg from '../assets/images/molla.png';
import '../styles/NotFound.scss';

const NotFound = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { urlLanguage } = useLang();

    return (
        <div className="notfound-page">
            <div className="notfound-card">
                {/* Left — Molla illustration */}
                <div className="notfound-image-col">
                    <img src={mollaImg} alt="Molla the wise wanderer" className="notfound-molla" />
                </div>

                {/* Right — Content */}
                <div className="notfound-content-col">
                    <p className="notfound-path">
                        You tried to open: <span>{location.pathname}</span>
                    </p>

                    <h1 className="notfound-title">404: Page not found.</h1>

                    <p className="notfound-description">
                        Molla says: instead of searching for what's lost,<br />
                        appreciate what's still here. Go back home — it's still standing!
                    </p>

                    <div className="notfound-actions">
                        <Link to={urlLanguage('/')} className="notfound-btn notfound-btn--primary">
                            Go to Home
                        </Link>
                        <button
                            className="notfound-btn notfound-btn--secondary"
                            onClick={() => navigate(-1)}
                        >
                            Go Back
                        </button>
                    </div>

                    <p className="notfound-debug">404 code visible for SEO / debugging</p>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
